// extracted by mini-css-extract-plugin
export default {"flex":"CY","imgwrap":"EY","image":"FY","textinfo":"GY","producttitle":"HY","bolder":"IY","block":"JY","info":"KY","moredetails":"LY","whitebox":"MY","old_price":"NY","discount":"OY"};
    if(module.hot) {
      // 1738836198181
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  